import { render, staticRenderFns } from "./PedidoOnline.vue?vue&type=template&id=2806c7d0&scoped=true"
import script from "./PedidoOnline.vue?vue&type=script&lang=js"
export * from "./PedidoOnline.vue?vue&type=script&lang=js"
import style0 from "./PedidoOnline.vue?vue&type=style&index=0&id=2806c7d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2806c7d0",
  null
  
)

export default component.exports